import * as React from "react";
import { FieldProps } from "formik";
import { Form, Slider } from "antd";
import type { SliderStyles, SliderClassNames } from "antd/es/slider";

const FormItem = Form.Item;

// Default slider styles that use CSS variables for consistency
const defaultSliderStyles: SliderStyles = {
  handle: {
    backgroundColor: 'var(--slider-handle-color)',
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    width: 'var(--slider-handle-size)',
    height: 'var(--slider-handle-size)',
    marginTop: -7, // Center the handle on the track
  },
  track: {
    backgroundColor: 'var(--slider-track-color)',
    height: 'var(--slider-track-height)',
  },
  rail: {
    backgroundColor: 'var(--slider-rail-color)',
    height: 'var(--slider-track-height)',
  },
 
};

const defaultSliderClassNames: SliderClassNames = {
  root: 'topup-slider-root',
  handle: 'topup-slider-handle',
  track: 'topup-slider-track',
  rail: 'topup-slider-rail',
};

export const SliderField: React.FC<
  FieldProps<any> & {
    prefix: React.ReactNode;
    label?: string;
    styles?: SliderStyles;
    classNames?: SliderClassNames;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  styles,
  classNames,
  ...props
}) => {
    const rawError = touched[field.name] && errors[field.name];
    const errorMsg =
      typeof rawError === "string"
        ? rawError
        : Array.isArray(rawError)
          ? rawError.join(", ")
          : rawError
            ? JSON.stringify(rawError)
            : undefined;

    // Merge default styles with provided styles
    const mergedStyles: SliderStyles = {
      ...defaultSliderStyles,
      ...styles,
      handle: { ...defaultSliderStyles.handle, ...styles?.handle },
      track: { ...defaultSliderStyles.track, ...styles?.track },
      rail: { ...defaultSliderStyles.rail, ...styles?.rail },
      root: { ...defaultSliderStyles.root, ...styles?.root },
    };

    const mergedClassNames: SliderClassNames = {
      ...defaultSliderClassNames,
      ...classNames,
    };

    return (
      <FormItem
      className="!w-full px-[1rem] !mr-[1rem]"
        label={label}
        help={errorMsg}
        validateStatus={errorMsg ? "error" : undefined}>
        <Slider
          className="!w-full "
          {...field}
          {...props}
          styles={mergedStyles}
          classNames={mergedClassNames}
          onChange={(newValue: any) => setFieldValue(field.name, newValue)} />
      </FormItem>
    );
  };